const APP_ENV_TEST = 'test';

// WHY: NEXT_PUBLIC_* は Next がリテラル参照のみをビルド時に値へ置換するため、定数キー経由の動的参照にはしない
export const isMockModeClient = (): boolean => process.env.NEXT_PUBLIC_MOCK_MODE === 'true';

export const isMockModeServer = (): boolean =>
  process.env.NEXT_PUBLIC_MOCK_MODE === 'true' && process.env.APP_ENV === APP_ENV_TEST;
